import React, { useRef, useState } from "react";
import mainStyle from "../../style/Main.module.css";
import MainLayout from "../../layouts/MainLayout";
import PageInputField from "../../components/ui/input/PagesInput/PagesInput";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import Button from "../../components/ui/buttons/Button";
import { MultiSelect } from "react-multi-select-component";
import Loader from "../../components/ui/Loader/Loader";
import Style from "../../style/Pages/Create&UpdateGrp.module.css";
import Select from "react-select";
import {
  useFetchSelectedUser,
  useSelectBoxCompany,
} from "../../hooks/useCommonHooks";
import { getRegisterId } from "../../utils/authId";
import { useCreateGroup } from "../../hooks/useGroup";

const CreateGroup = () => {
  const fileinput = useRef(null);
  const currentUserId = getRegisterId();

  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const users = useFetchSelectedUser(selectedCompanyId);
  const companyList = useSelectBoxCompany();
  // const [previewImage, setPreviewImage] = useState(images.group);

  const {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    setFormData,
    previewImage,
    setPreviewImage,
    setError,
  } = useCreateGroup();

  const companyOptions = companyList.map((company) => ({
    label: company.company_name,
    value: company.id,
  }));

  const handleCompanyChange = (option) => {
    setSelectedCompanyId(option.value);
    setFormData((prev) => ({
      ...prev,
      company: option.value,
    }));
    setError((prev) => ({ ...prev, company: "" }));
  };
  const userOptions = users.map((user) => ({
    label: user.name,
    value: user.id,
  }));
  const handlePeopleChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      group_user: [currentUserId, ...selected.map((option) => option.value)],
      group_admin: [currentUserId],
    }));
    setError((prev) => ({ ...prev, group_user: "" }));
  };

  const handleOnlickDiv = () => {
    fileinput.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return;
    setPreviewImage(URL.createObjectURL(file));
    handleInputChange({
      target: { name: "group_icon", value: file }, // store file
    });
  };

  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p className={mainStyle.mainHeading}>Create Group:</p>
        </div>
        <div className={mainStyle.mainPageButtons}></div>
      </div>

      {/* {showFilter && (
      <div className={mainStyle.mainPageFilter}>
        <p>This is your filter section</p>
      </div>
    )} */}

      <div className={mainStyle.mainContentView} style={{ height: "84%" }}>
        <div className={mainStyle.mainContentViewsb}>
          <div className={mainStyle.mainContentCard}>
            <p className={mainStyle.aboutPageContent}>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Welcome to our
              Create a group to simplify team communication and collaboration.
              Add a name, choose public or private, invite members, and assign
              admins to manage it.
            </p>
            <div className={mainStyle.mainContentForm}>
              <div className={mainStyle.mainContentFormSplit}>
                {/* <PageInputField
                  label="First Name"
                  name="first_name"
                  placeholder="e.g., John"
                  required
                  value={formData.first_name || ""}
                  onChange={handleInputChange}
                  error={error.first_name}
                /> */}
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Group Icon
                  </label>
                  <div className={Style.groupIconDiv} onClick={handleOnlickDiv}>
                    <div>
                      {" "}
                      <img src={previewImage} alt="Group Icon" />
                    </div>
                    <input
                      type="file"
                      ref={fileinput}
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                  </div>
                </div>
                <p className={mainStyle.contentGuideOrd}>
                  Note : Upload an image or choose an icon to visually represent
                  your group. This helps members quickly identify the group in
                  the chat list.{" "}
                </p>
              </div>
              {/* <p className={mainStyle.contentGuideOrd}>
                Note : You will receive your password in this email after
                completing your registration
              </p>
              <PageInputField
                label="Email"
                name="email"
                placeholder="e.g., john.doe@example.com"
                required
                value={formData.email || ""}
                onChange={handleInputChange}
                error={error.email}
              /> */}
              <div className={mainStyle.mainContentFormSplit}>
                <PageInputField
                  label="Group Name"
                  name="group_name"
                  placeholder="What will you like to call this group"
                  required
                  value={formData.group_name || ""}
                  onChange={handleInputChange}
                  error={error.group_name}
                />
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Company<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <Select
                    className={mainStyle.selectBoxPage}
                    options={companyOptions}
                    onChange={handleCompanyChange}
                    value={companyOptions.find(
                      (option) => option.value === formData.company
                    )}
                  />
                  {error.company && (
                    <span className={mainStyle.errorMsg}>{error.company}</span>
                  )}
                </div>
              </div>
              <p className={mainStyle.contentGuideOrd}>
                Note : Select multiple users to add them to the group. The
                chosen members will be part of the group and can participate in
                all chats and activities. You can select as many users as needed
                to ensure the right team is included.
              </p>
              <div className={mainStyle.mainContentFormSplit}>
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Staff<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <MultiSelect
                    options={userOptions}
                    value={userOptions.filter((option) =>
                      formData.group_user?.includes(option.value)
                    )}
                    onChange={handlePeopleChange}
                    labelledBy="Select Companies"
                    className={mainStyle.mutiSelectDropDown}
                    overrideStrings={{
                      allItemsAreSelected: "All Staff selected",
                      selectSomeItems: "Select Staff",
                    }}
                  />
                  {error.group_user && (
                    <span className={mainStyle.errorMsg}>
                      {error.group_user}
                    </span>
                  )}
                </div>

                {/* <SelectBox
                                    options={companyList}
                                    label="Company"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleInputChange}  // Add this line
                                    placeholder="select a company"
                                    required
                                    multiple

                                    error={error.company}
                                /> */}
                <div
                  className={mainStyle.mainButtonDiv}
                  style={{ width: "100%" }}
                >
                  <Button onClick={handleSubmit}>
                    {" "}
                    {loading ? <Loader /> : "Invite"}
                  </Button>
                </div>
              </div>

              <br />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default CreateGroup;
